export const formatDate = (format = 'yyyy-mm-dd', dateString) => {
  const date = new Date(dateString);
  let formattedDate = null;

  if (dateString) {
    function pad(value) {
      return String(value).padStart(2, '0');
    }

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());

    formattedDate = format.replace(/yyyy/g, year).replace(/mm/g, month).replace(/dd/g, day);
  }

  return formattedDate;
};

export const formatPeriodDate = (date) => {
  const year = date.slice(0, 4);
  const half = date.slice(4);
  return `${half} - ${year}`;
};
